'use strict';

var TOAST_DURATION_MS = 2500;
var DESKTOP_MIN_WIDTH = 992;
var hideTimer = null;
var suppressToastUntil = 0;

function isDesktop() {
    return window.matchMedia('(min-width: ' + DESKTOP_MIN_WIDTH + 'px)').matches;
}

function isMiniCartOpen() {
    return $('.mini-cart-content').hasClass('mini-cart-show');
}

function isToastSuppressed() {
    return Date.now() < suppressToastUntil;
}

function getToastEls() {
    var $toast = $('.toastMessage');
    return {
        $toast: $toast,
        $container: $toast.find('.js-toast-message-container')
    };
}

function positionBelowHeader($toast) {
    var $header = $('header .header.container, header nav .header, .header.container').first();
    var top = 88;

    if ($header.length) {
        var rect = $header[0].getBoundingClientRect();
        top = Math.max(rect.bottom + 8, 72);
    }

    $toast.css('top', top + 'px');
}

function clearHideTimer() {
    if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
    }
}

/**
 * Slides the cart toast out of view.
 */
function hideCartToast() {
    var els = getToastEls();
    var $toast = els.$toast;

    if (!$toast.length || !$toast.hasClass('toastVisible')) {
        clearHideTimer();
        return;
    }

    clearHideTimer();
    $toast.removeClass('toastVisible toastMessage--removed');
}

/**
 * Shows the cart confirmation toast.
 * Omitted on mobile and when the side cart is already open.
 * @param {string} toastHtml - Rendered cartToastContent HTML
 */
function showCartToast(toastHtml) {
    if (!isDesktop() || !toastHtml || !String(toastHtml).trim()) {
        return;
    }

    if (isMiniCartOpen() || isToastSuppressed()) {
        return;
    }

    var els = getToastEls();
    var $toast = els.$toast;
    var $container = els.$container;

    if (!$toast.length || !$container.length) {
        return;
    }

    clearHideTimer();
    positionBelowHeader($toast);

    // Clear previous status classes before injecting new markup (avoids check → removed flicker)
    $toast.removeClass('toastMessage--removed');
    $container.html(toastHtml);

    var isRemoved = $container.find('.cart-toast-content').attr('data-action') === 'removed';
    $toast.toggleClass('toastMessage--removed', !!isRemoved);

    // Restart slide-in if already visible
    $toast.removeClass('toastVisible');
    // Force reflow so the transition runs again
    void $toast[0].offsetWidth; // eslint-disable-line no-void
    $toast.addClass('toastVisible');

    hideTimer = setTimeout(hideCartToast, TOAST_DURATION_MS);
}

function openSideCart(e) {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }

    // Prevent any in-flight remove/update toast from replacing the icon while opening the cart
    suppressToastUntil = Date.now() + 1000;
    hideCartToast();

    var $miniCartContent = $('.mini-cart-content');
    if (!$miniCartContent.length || $miniCartContent.hasClass('mini-cart-show')) {
        return;
    }

    $('body').addClass('navbar--opened');
    $miniCartContent.removeClass('mini-cart-no-trans').addClass('mini-cart-show');
    $('.mini-cart-link').attr('aria-expanded', 'true');
}

function onBasketRemove(event) {
    var removedPid = event && event.pid ? String(event.pid) : null;
    if (!removedPid) {
        return;
    }

    var els = getToastEls();
    var $toast = els.$toast;
    if (!$toast.hasClass('toastVisible')) {
        return;
    }

    var $content = $toast.find('.cart-toast-content');
    var toastPid = $content.attr('data-pid');
    var action = $content.attr('data-action');

    // Dismiss only an "added" toast when that product is fully removed.
    // "removed" toasts are shown by the remove response itself.
    if (action === 'added' && toastPid && String(toastPid) === removedPid) {
        hideCartToast();
    }
}

function init() {
    $('body')
        .off('click.cartToast', '.js-cart-toast-open-cart')
        .on('click.cartToast', '.js-cart-toast-open-cart', openSideCart);

    $(document)
        .off('cartToastShow.cartToast')
        .on('cartToastShow.cartToast', function (event, toastHtml) {
            showCartToast(toastHtml);
        });

    $(document)
        .off('cartToastHide.cartToast')
        .on('cartToastHide.cartToast', function () {
            hideCartToast();
        });

    $(document)
        .off('basketremove.cartToast')
        .on('basketremove.cartToast', onBasketRemove);

    $(window)
        .off('resize.cartToast')
        .on('resize.cartToast', function () {
            if (!isDesktop()) {
                hideCartToast();
            } else if ($('.toastMessage').hasClass('toastVisible')) {
                positionBelowHeader($('.toastMessage'));
            }
        });
}

function initCartToast() {
    init();
}

initCartToast.show = showCartToast;
initCartToast.hide = hideCartToast;
initCartToast.showCartToast = showCartToast;
initCartToast.hideCartToast = hideCartToast;
initCartToast.init = init;

module.exports = initCartToast;
